/* This file was copied from z__jsCollection.js and slightly altered to support the plug__collection section. */

/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};

    window.PLUG = window.PLUG || Object.create(null);
    window.PLUG.initializedCollectionSections = window.PLUG.initializedCollectionSections || new WeakSet();

    if (!window.customElements.get("plug-filter-tooltip")) {
        class PlugFilterTooltip extends HTMLElement {
            constructor() {
                super();
                this.removeBodyListener = undefined;
                this.mouseoutTimer = undefined;
            }

            connectedCallback() {
                this.addEventListener("click", (e) => {
                    e.stopPropagation();

                    this.toggle();
                }, false);

                this.addEventListener("mouseenter", () => {
                    if (this.mouseoutTimer) {
                        clearTimeout(this.mouseoutTimer);
                    }
                    if (window.innerWidth > 500) {
                        this.open();
                    }
                });

                this.addEventListener("mouseleave", () => {
                    if (window.innerWidth > 500) {
                        this.mouseoutTimer = setTimeout(() => {
                            this.close();
                        }, 150);
                    }
                });
            }

            computeBestPosition() {
                // Mobile only.
                // Returns "left", "center" or "right", indicating the horizontal alignment of the tooltip
                // text with the icon.
                if (this.offsetLeft >= 140) {
                    //      icon
                    // text text
                    return "left";
                } else if (this.offsetParent.offsetWidth - this.offsetLeft >= 140) {
                    return "right";
                } else {
                    return "center";
                }
            }

            isMobile() {
                return window.innerWidth < 1200;
            }

            open() {
                console.log("Open");
                this.dataset.isOpen = "true";
                if (this.isMobile()) {
                    this.dataset.mobileTextPosition = this.computeBestPosition();
                }
                const handleBodyClick = () => {
                    this.close();
                };
                document.body.addEventListener("click", handleBodyClick, false);
                this.removeBodyListener = () => {
                    document.body.removeEventListener("click", handleBodyClick, false);
                };
            }

            close() {
                this.dataset.isOpen = "false";
                if (typeof this.removeBodyListener === "function") {
                    this.removeBodyListener();
                }
            }

            toggle() {
                if (this.dataset.isOpen === "true") {
                    this.close();
                } else {
                    this.open();
                }
            }
        }
        window.customElements.define("plug-filter-tooltip", PlugFilterTooltip);
    }

    if (!window.PLUG.collectionFilters) {
        const CollectionFilters = function () {
            const updateHandlers = {};

            function runPageLoadTasks() {
                updateSliderActiveFilters();
                const sliders = Array.from(
                    document.querySelectorAll("plug-range-slider, plug-fraction-range-slider")
                );
                if (sliders.some(slider => slider.currentRangeHasNoResults)) {
                    const filterDataScript = document.querySelector(".plug-dev-filter-data");
                    if (filterDataScript) {
                        const filters = JSON.parse(filterDataScript.textContent).filterData;
                        updateFilters(document.querySelector(".faceted-filter-form--mobile"), filters, true);
                        updateFilters(document.querySelector(".faceted-filter-form--desktop"), filters, true);
                    }
                    const matrix = document.querySelector(".collection-matrix");
                    const pagination = document.querySelector(".collection-matrix__wrapper .container--pagination");
                    if (matrix) {
                        matrix.style.display = "none";
                    }
                    if (pagination) {
                        pagination.style.display = "none";
                    }
                }
                const hideSidebarButton = document.querySelector(".sidebar__hide-button");
                if (hideSidebarButton) {
                    hideSidebarButton.addEventListener("click", () => {
                        const collectionInner = document.querySelector(".plug-collection-inner");
                        if (collectionInner) {
                            collectionInner.dataset.sidebarCollapsed = "true";
                        }
                    });
                }
                const showFiltersButton = document.querySelector(".collection__show-filters-button");
                if (showFiltersButton) {
                    showFiltersButton.addEventListener("click", () => {
                        const collectionInner = document.querySelector(".plug-collection-inner");
                        if (collectionInner) {
                            if (collectionInner.dataset.sidebarCollapsed === "true") {
                                collectionInner.dataset.sidebarCollapsed = "false";
                            } else {
                                collectionInner.dataset.sidebarCollapsed = "true";
                            }
                        }
                    });
                }
            }

            setTimeout(runPageLoadTasks, 0);

            function updateSliderActiveFilters(html = document) {
                const activeSliderFilters = Array.from(
                    html.querySelectorAll(".active-filters__remove-filter.is-plug-slider-filter")
                );
                activeSliderFilters.forEach(activeFilter => {
                    const metaobjectId = activeFilter.dataset.metaobjectId;
                    const slider = document.getElementById(`${metaobjectId}-desktop`);
                    if (slider && typeof slider.reformatActiveFilter === "function") {
                        slider.reformatActiveFilter(activeFilter);
                    }
                });
                const rangeSliders = Array.from(
                    document.querySelectorAll("plug-range-slider, plug-fraction-range-slider")
                );
                rangeSliders.forEach(slider => slider.buildActiveFilter(html));
            }

            function subscribeToUpdate(cb) {
                const symbol = Symbol();
                updateHandlers[symbol] = cb;
                return () => {
                    if (symbol in updateHandlers) {
                        delete updateHandlers[symbol];
                    }
                };
            }

            /**
             * Create a new URL based on form data and pass it to the jsCollection.updateView handler.
             *
             * @param {HTMLFormElement} form
             * @param {{quitEarly: boolean}} [quitEarlyObject]
             */
            function handleChange(form, quitEarlyObject) {
                const t0 = Date.now();
                const formData = new FormData(form);
                const newSearchParams = new URLSearchParams();
                for (const pair of formData.entries()) {
                    newSearchParams.append(pair[0], pair[1]);
                }
                const currentSearchParams = new URLSearchParams(location.search);
                const sortBy = currentSearchParams.get('sort_by');
                const defaultView = currentSearchParams.get('default_view');
                if (sortBy) {
                    newSearchParams.set('sort_by', sortBy);
                }
                if (defaultView) {
                    newSearchParams.set('default_view', defaultView);
                }
                const newFilterUrl = `${location.protocol}//${location.host}${location.pathname}?${newSearchParams.toString()}`;
                const filterParams = {};
                for (const param of newSearchParams.entries()) {
                    if (param[0] in filterParams) {
                        filterParams[param[0]].push(param[1]);
                    } else {
                        filterParams[param[0]] = [param[1]];
                    }
                }
                Object.keys(updateHandlers).forEach(key => updateHandlers[key]());
                window.PXUTheme.jsCollection.updateView(newFilterUrl, quitEarlyObject, t0);
            }

            /**
             * Update the form filters' state based on filter data returned by Shopify.
             *
             * @param {HTMLFormElement} form
             * @param {Filter[]} filters
             * @param {boolean} noResults
             */
            function updateFilters(form, filters, noResults = false) {
                if (!form || !Array.isArray(filters)) {
                    return;
                }

                filters.forEach(filter => {
                    const block = form.querySelector(`.plug-filter-block[data-filter-param-name="${filter.paramName}"]`);
                    if (!block) {
                        return console.log(`Can't find block for filter: ${filter.paramName}.`);
                    }

                    if (block.dataset.hasValuesSlider === "true" || block.dataset.hasRangeSlider === "true") {
                        return;
                    }

                    filter.values.forEach(filterValue => {
                        const input = block.querySelector(`input[data-label="${filterValue.label}"]`);
                        if (!input) {
                            return console.log(`Can't find input for filterValue: ${filter.paramName}.${filterValue.label}`);
                        }
                        const isDisabled = (!filterValue.active && (noResults || !filterValue.count));
                        input.disabled = isDisabled;
                        const label = input.closest("label");
                        if (label) {
                            label.dataset.inputDisabled = isDisabled ? "true" : "false";
                        }
                        const count = label && label.querySelector(".faceted-filter-value-count");
                        if (count) {
                            count.textContent = noResults ? "0" : filterValue.count;
                        }
                    });
                });
            }


            function setupFilterGroupListeners() {
                const toggleButtons = Array.from(
                    document.getElementsByClassName("sidebar-block__toggle-button")
                );
                const viewMoreButtons = Array.from(
                    document.getElementsByClassName("faceted-filter-group-display__toggle-more")
                );
                const searchInputs = Array.from(
                    document.querySelectorAll('.faceted-filter-group-display__search input')
                );

                toggleButtons.forEach(button => {
                    button.addEventListener("click", () => {
                        const parentBlock = button.closest(".sidebar__block");
                        const isOpen = parentBlock.dataset.filterState === "expanded";
                        parentBlock.dataset.filterState = isOpen ? "collapsed" : "expanded";
                        const content = parentBlock.querySelector(".sidebar-block__content");
                        if (!isOpen && content && content.dataset.hasRangeSlider === "true") {
                            const rangeSlider = content.querySelector("plug-range-slider, plug-fraction-range-slider");
                            if (rangeSlider && rangeSlider.measure) {
                                rangeSlider.measure();
                            }
                        }
                    }, false);
                });

                viewMoreButtons.forEach(button => {
                    button.addEventListener("click", () => {
                        const parentBlock = button.closest(".sidebar__block");
                        const isShowingAll = parentBlock.dataset.showingAll === "true";
                        parentBlock.dataset.showingAll = isShowingAll ? "false" : "true";
                    }, false);
                });

                searchInputs.forEach(input => {
                    input.addEventListener("input", () => {
                        const block = input.closest(".plug-filter-block");
                        const query = input.value.toLowerCase();
                        const filterListItems = Array.from(
                            block.getElementsByClassName("plug-filter-value")
                        );
                        const showMoreButton = block.querySelector(".faceted-filter-group-display__toggle-more");

                        let numMatches = 0;
                        filterListItems.forEach(listItem => {
                            const value = listItem.querySelector(".plug-filter-value-text").textContent;
                            const words = value.split(" ").map(word => word.toLowerCase());
                            if (words.some(word => startsWith(word, query))) {
                                listItem.classList.add("is-search-match");
                                if (showMoreButton) {
                                    if (numMatches < 5) {
                                        listItem.classList.add("is-search-match-preview");
                                    } else {
                                        listItem.classList.remove("is-search-match-preview");
                                    }
                                }
                                numMatches += 1;
                            } else {
                                listItem.classList.remove("is-search-match");
                                if (showMoreButton) {
                                    listItem.classList.remove("is-search-match-preview");
                                }
                            }
                        });
                        if (query.length) {
                            block.dataset.searchApplied = "true";
                        } else {
                            block.dataset.searchApplied = "false";
                        }
                        if (showMoreButton) {
                            if (query.length && numMatches <= 5) {
                                block.classList.add("is-not-showing-view-buttons");
                            } else {
                                block.classList.remove("is-not-showing-view-buttons");
                            }
                        }
                    });
                });
            }

            function startsWith(string, prefix) {
                return (
                    typeof string === "string"
                    && typeof prefix === "string"
                    && prefix.length > 0
                    && string.length >= prefix.length
                    && prefix.split("").every((char, index) => char === string[index])
                );
            }

            return Object.freeze({
                handleChange,
                updateFilters,
                subscribeToUpdate,
                updateSliderActiveFilters,
                setupFilterGroupListeners,
            });
        };

        window.PLUG.collectionFilters = CollectionFilters();
    }

    window.PXUTheme.jsCollection = {
        init: function($section) {
            if (!$section || !$section.length) {
                console.warn("jsCollection initialization skipped: collection section not found.");
                return;
            }

            const sectionElement = $section[0];
            if (window.PLUG.initializedCollectionSections.has(sectionElement)) {
                return;
            }

            // Add settings from schema to current object
            window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

            // function to check if browser is IE
            var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

            // Ensure product media libraries are present
            if (!isIE11) {
                window.Shopify.loadFeatures([
                    {
                        name: 'shopify-xr',
                        version: '1.0',
                    },
                    {
                        name: 'model-viewer-ui',
                        version: '1.0',
                    }
                ],)
            }

            if (this.enable_sorting == true) {
                $('#sort-by').val($('#sort-by').data('default-sort'));
            }

            if (this.enable_filter == true || this.enable_sorting == true) {
                $('#tag_filter, #sort-by').on('change', function() {
                    window.PXUTheme.jsCollection.filterURL();
                });
            }

            if ($('[data-option-filter]').length) {
                // Show enabled filter tags based on selected checkboxes
                $('[data-tag-filter-checkbox]:checked').each(function(){
                    window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
                })
            }

            // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
            if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
                window.PXUTheme.breadcrumbs.init(this.number_of_pages);
            }

            /* Collection sidebar filter */
            $('body').on('click', '[data-option-filter]', function(e) {
                e.preventDefault();
                $(this).find('input').prop('checked', true);
                window.PXUTheme.jsCollection.multiTagFilter.init($(this));
                window.PXUTheme.scrollToTop($('.collection__content'));
            });

            $('body').on('click', '[data-clear-filter]', function () {
                const $el = $(this).siblings('[data-option-filter]');
                const $productTagFilter = $('#tag_filter');
                $productTagFilter.find('option:eq(0)').prop('selected', true);
                window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
                window.PXUTheme.scrollToTop($('.collection__content'));
            });

            window.PLUG.collectionFilters.setupFilterGroupListeners();

            $('.faceted-filter-form').on('change', 'input', function(e) {
                if (e.currentTarget.classList.contains('plug-filter-search')) {
                    return;
                }
                window.PLUG.collectionFilters.handleChange($(this).parents('.faceted-filter-form')[0]);
                return;
            })
            window.PLUG.initializedCollectionSections.add(sectionElement);
        },
        filterURL: function() {
            var selectedOptions = [],
                query = '',
                currentTags = '',
                siteUrl = 'https://' + $.url('hostname');

            // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
            if (window.PXUTheme.routes.root_url.length > 1) {
                var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
                var url2 = $.url('2') ? $.url('2') + '/' : '';
                var url3 = $.url('3') ? $.url('3') + '/' : '';
                var path = url1 + url2 + url3;
            } else {
                var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
                var url2 = $.url('2') ? $.url('2') + '/' : '';
                var path = url1 + url2;
            }

            //Handle dropdowns if they exist
            if ($('#sort-by').length){
                query = $('#sort-by').val();
            } else {
                query = url('?sort_by');
            }

            if ($('#tag_filter').length){

                if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
                    var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

                    if (urlTag != 'all'){
                        if ($.inArray( urlTag, selectedOptions ) > -1){
                            //Do nothing
                        } else {
                            selectedOptions.unshift(urlTag);
                        }
                    }
                }
            }

            //Add all checkbox values to array
            $('[data-option-filter] input:checked').each(function () {
                selectedOptions.push($(this).val());
            });

            selectedOptions = $.makeArray(selectedOptions);

            //Loop through tags to create string to update page url
            $.each(selectedOptions, function(i, value){

                if (i != selectedOptions.length - 1) {
                    currentTags += selectedOptions[i] + '+';
                } else {
                    currentTags += selectedOptions[i];
                }

            });

            window.PXUTheme.queryParameters.sort_by = query;
            query = '?' + $.param(window.PXUTheme.queryParameters);
            var sort_by = window.PXUTheme.queryParameters.sort_by;
            this.processUrl(path, currentTags, query,sort_by);
        },
        processUrl: function (path, tags, query, sort_by) {
            var query = query.replace(/\page=(\w+)&/, ''),
                urlString = '';

            urlString = path + query;
            var url = window.location.href;
            var default_view = getParameterByName("default_view");
            if (url.includes('?')) {
                var url_split_1 = url.split('?');
                var url_split_2 = url_split_1[1].split('&')
                for (let i = 0; i < url_split_2.length; i++) {
                    if (url_split_2[i].includes('sort_by') || url_split_2[i].includes('default_view')) {
                        url_split_2[i] = ''
                    }
                }
                url_split_2 = url_split_2.join('&') + '&sort_by=' + sort_by;
                url = path + '?' + url_split_2;
                url = url.replaceAll('&&', '&').replaceAll('?&', '?');
                urlString = urlString + '&' + url;
            } else {
                url = url + '?sort_by=' + sort_by;
            }
            var view_class = "." + default_view;
            if (default_view == undefined || default_view == '') {

            } else {
                url = url.replaceAll('&default_view=list', '');
                url = url.replaceAll('&default_view=grid', '');
                url = url.replaceAll('?default_view=list', '');
                url = url.replaceAll('?default_view=grid', '');
                url = url.replaceAll('&default_view=', '');
                url = url.replaceAll('?default_view=', '');
                url = url.replaceAll('view=active_filters', '');
                if (url.includes('?')) {
                    url = url + "&default_view=" + default_view;
                } else {
                    url = url + "?default_view=" + default_view;
                }
            }
            this.updateView(url);
        },
        updateView: function(filterURL, quitEarlyObject, t0) {
            const originalFilterUrl = filterURL;
            const section = document.querySelector(".plug-collection-page");
            if (section) {
                if (filterURL.includes("?")) {
                    filterURL = filterURL.replace("?", `?section_id=${section.dataset.sectionId}&`);
                } else {
                    filterURL += `?section_id=${section.dataset.sectionId}`;
                }
            }
            $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
            $.ajax({
                type: 'GET',
                url: filterURL,
                success: function(data) {
                },
                error: function(x, t, m) {
                    console.log(x);
                    console.log(t);
                    console.log(m);
                    location.replace(originalFilterUrl);
                },
                dataType: "html"
            }).then(function(data){
                if (quitEarlyObject && quitEarlyObject.quitEarly) {
                    return;
                }
                const parser = new DOMParser();
                const dataDoc = parser.parseFromString(data, 'text/html');
                // const $breadcrumbContainer = $('.breadcrumb__container');
                // const $collectionMatrix = $('.collection-matrix');
                const $collectionMain = $('[data-plug-collection-main]');

                // Get and set new breadcrumb html
                // const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
                // $breadcrumbContainer.html(filteredBreadcrumb);

                // Remove loading animation
                // $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

                window.history.pushState(null, "", originalFilterUrl);

                // Check for products
                // const filteredData = $(data).find('.collection-matrix__wrapper');
                const filteredData = $(data).find('[data-plug-collection-main]');

                Array.from(
                    document.querySelectorAll("plug-values-slider, plug-range-slider, plug-fraction-range-slider")
                ).forEach(slider => {
                    const newSlider = dataDoc.getElementById(slider.id);
                    const parent = slider.parentElement;
                    if (newSlider && parent) {
                        parent.replaceChild(newSlider, slider);
                    }
                });
                //
                // Array.from(document.getElementsByTagName("plug-values-slider")).forEach(valuesSlider => {
                //     const newSlider = dataDoc.getElementById(valuesSlider.id);
                //     const parent = valuesSlider.parentElement;
                //     parent.removeChild(valuesSlider);
                //     parent.appendChild(newSlider);
                // });
                //
                // Array.from(document.getElementsByTagName("plug-range-slider")).forEach(rangeSlider => {
                //     const newSlider = dataDoc.getElementById(rangeSlider.id);
                //     const parent = rangeSlider.parentElement;
                //     parent.removeChild(rangeSlider);
                //     parent.appendChild(newSlider);
                // });
                //
                // Array.from(document.getElementsByTagName("plug-fraction-range-slider")).forEach(rangeSlider => {
                //     const newSlider = dataDoc.getElementById(rangeSlider.id);
                //     const parent = rangeSlider.parentElement;
                //     parent.removeChild(rangeSlider);
                //     parent.appendChild(newSlider);
                // });

                // document.querySelector(".faceted-filters-form__title").textContent = dataDoc.querySelector(".faceted-filters-form__title").textContent;
                // $('.faceted-filters-form__title').html($(data).find('.faceted-filters-form__title').html());

                window.requestAnimationFrame(() => {
                    setTimeout(() => {
                        if (filteredData.length) {
                            const newPlugCollectionMain = filteredData[0];
                            window.PLUG.collectionFilters.updateSliderActiveFilters(newPlugCollectionMain);
                            const filterScript = dataDoc.querySelector(".plug-dev-filter-data");
                            // const $filterScript = $(data).find(".plug-dev-filter-data");
                            if (filterScript) {
                                const filters = JSON.parse(filterScript.innerHTML).filterData;
                                const mobileForm = document.querySelector(".faceted-filter-form--mobile");
                                const desktopForm = document.querySelector(".faceted-filter-form--desktop");
                                const sliders = Array.from(
                                    document.querySelectorAll("plug-range-slider, plug-fraction-range-slider")
                                );
                                const hasNoResults = sliders.some(slider => slider.currentRangeHasNoResults);
                                if (hasNoResults) {
                                    const matrix = filteredData.find(".collection-matrix");
                                    const pagination = filteredData.find(".container--pagination");
                                    if (matrix.length) {
                                        matrix[0].style.display = "none";
                                    }
                                    if (pagination.length) {
                                        pagination[0].style.display = "none";
                                    }
                                }
                                window.PLUG.collectionFilters.updateFilters(mobileForm, filters, hasNoResults);
                                window.PLUG.collectionFilters.updateFilters(desktopForm, filters, hasNoResults);
                            }
                            // Add products to container
                            $collectionMain.empty();
                            $collectionMain.append(filteredData);
                        } else {
                            const noProducts = $(data).find('.container--no-products-in-collection');
                            // Display no product message
                            $collectionMain.empty();
                            $collectionMain.append(noProducts);
                        }

                        // Initiate infinite scrolling on new products appended to collection grid
                        if ($('[data-custom-pagination]').length) {
                            window.PXUTheme.infiniteScroll.init();
                        }
                        var getParameterByName=	function(paramatername) {
                            paramatername = paramatername.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                            var regex = new RegExp("[\\?&]" + paramatername + "=([^&#]*)");
                            results = regex.exec(location.search);
                            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
                        }
                        var url = window.location.href;
                        var default_view = getParameterByName("default_view");
                        var view_class = "." + default_view;
                        if (default_view == undefined || default_view == '') {

                        } else {
                            $('.view-toggle' + view_class).addClass('active');
                            $('.view-toggle' + view_class).siblings().removeClass('active');
                            $('.subcollection__view-container[view="' + default_view + '"]').addClass('active');
                            $('.subcollection__view-container[view="' + default_view + '"]').siblings().removeClass('active');
                            $('.active-filters__clear, .pagination-link, .active-filters__remove-filter, .filter-group-display__header-reset, .pagination-next, .pagination-previous').each(function(){
                                var link = $(this).attr('href');
                                if (link == undefined || link == '')  {

                                } else {
                                    link = link.replaceAll('&default_view=list', '');
                                    link = link.replaceAll('&default_view=grid', '');
                                    link = link.replaceAll('?default_view=list', '');
                                    link = link.replaceAll('?default_view=grid', '');
                                    link = link.replaceAll('&default_view=', '');
                                    link = link.replaceAll('?default_view=', '');
                                    link = link.replaceAll('view=active_filters', '');
                                    if (link.includes('?')) {
                                        link = link + "&default_view=" + default_view;
                                    } else {
                                        link = link + "?default_view=" + default_view;
                                    }
                                    $(this).attr('href', link)
                                }
                            })
                        }
                    }, 0);
                });
            })
                .catch(e => {
                    console.error(e);
                    $('.collection-matrix').removeClass('fadeOut animated loading-in-progress');
                });
        },
        multiTagFilter: {
            init: function ($el) {

                // Show filter and hide siblings
                this.showSelectedFilter($el);

                // Update url
                window.PXUTheme.jsCollection.filterURL();

                var urlIndex;
                if (window.PXUTheme.routes.root_url.length > 1) {
                    urlIndex = 3
                } else {
                    urlIndex = 2
                }

                // Hide filters if types or vendors is in URL (can't be combined)
                if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
                    $('.block__tag-filter').remove();
                }

            },
            showSelectedFilter: function ($el) {
                const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
                const $filterItem = $el.parents('.tag-filter__item');

                $filterItem.addClass('is-active');
                $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
                $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

                // If sidebar toggle is enabled, show filter in sidebar content
                if ($sidebarToggleBlock.length) {
                    let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

                    window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
                }

            },
            clearSelectedFilter: function ($el) {

                const $filterItem = $el.parents('.tag-filter__item');

                $filterItem.removeClass('is-active')
                    .find('input').prop("checked", false);
                $filterItem.siblings()
                    .removeClass('is-hidden');
                $filterItem.find('[data-clear-filter]')
                    .addClass('is-hidden');

                //Update url
                window.PXUTheme.jsCollection.filterURL();
            }
        },
        unload: function($section) {
            $('#tag_filter, #sort-by').off();
            $('[data-option-filter]').off();
            $('[data-reset-filters]').off();
            $('[data-clear-filter]').off();
            window.PXUTheme.breadcrumbs.unload();
        }
    }

    // The theme normally initializes jsCollection during its document-ready section scan.
    // Initialize here as well so this section does not depend on cross-file callback order.
    function initializePlugCollectionWhenReady() {
        const section = document.querySelector(".shopify-section.jsCollection");
        if (section) {
            window.PXUTheme.jsCollection.init($(section));
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializePlugCollectionWhenReady, { once: true });
    } else {
        initializePlugCollectionWhenReady();
    }
    /******/ })()
;
